import React from "react";

// Varied width sets per column so rows look natural, not uniform
const TITLE_WIDTHS    = ["72%", "55%", "85%", "60%", "78%", "50%", "90%", "65%", "48%", "80%"];
const COMPANY_WIDTHS  = ["60%", "75%", "50%", "68%", "82%", "55%", "70%", "45%", "78%", "63%"];
const LOC_WIDTHS      = ["65%", "80%", "55%", "72%", "48%", "85%", "60%", "70%", "52%", "75%"];
const DEPT_WIDTHS     = ["75%", "55%", "90%", "65%", "80%", "50%", "70%", "60%", "85%", "45%"];
const SENIO_WIDTHS    = ["55%", "65%", "45%", "70%", "50%", "60%", "75%", "40%", "68%", "58%"];
const CLOC_WIDTHS     = ["60%", "78%", "52%", "70%", "85%", "48%", "65%", "80%", "55%", "72%"];
const SIZE_WIDTHS     = ["50%", "65%", "40%", "55%", "70%", "45%", "60%", "50%", "75%", "42%"];
const REV_WIDTHS      = ["55%", "70%", "45%", "60%", "75%", "50%", "65%", "40%", "80%", "55%"];
const INDUS_WIDTHS    = ["70%", "55%", "80%", "65%", "48%", "85%", "60%", "75%", "50%", "68%"];
const CTYPE_WIDTHS    = ["60%", "75%", "50%", "70%", "55%", "80%", "45%", "65%", "70%", "52%"];
const EMAIL_WIDTHS    = ["80%", "65%", "90%", "70%", "55%", "85%", "60%", "75%", "50%", "78%"];
const PHONE_WIDTHS    = ["55%", "70%", "48%", "65%", "78%", "50%", "62%", "72%", "45%", "58%"];

// height=16 matches ~13px font rendered with line-height 1.4 (~18px)
const Shimmer = ({ width, height = 16, style = {} }) => (
  <span
    className="lbSkeleton"
    style={{ width, height, borderRadius: 6, display: "block", ...style }}
  />
);

const ContactTableLoader = ({ count = 10 }) => {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div className="contact contactTableLoader" key={`skeleton-${i}`}>
          {/* ── Contact (sticky) ── */}
          <div className="stickyLeftCol" role="presentation">
            <div className="ctSelectAll dataContainer">
              <Shimmer width={16} height={16} style={{ borderRadius: 3 }} />
            </div>
            <div className="nameCont dataContainer">
              {/* Avatar circle */}
              <span className="lbSkeleton lbSkeleton--circle" style={{ width: 34, height: 34, borderRadius: "50%", flexShrink: 0, marginRight: 10 }} />
              <div style={{ display: "flex", flexDirection: "column", gap: 2, flex: 1, minWidth: 0 }}>
                <Shimmer width={COMPANY_WIDTHS[i % 10]} height={16} />
                {/* social link icons */}
                <span style={{ display: "flex", gap: 4, marginTop: 1 }}>
                  <span className="lbSkeleton" style={{ width: 16, height: 16, borderRadius: "50%" }} />
                  <span className="lbSkeleton" style={{ width: 16, height: 16, borderRadius: "50%" }} />
                </span>
              </div>
            </div>
          </div>

          {/* ── Title ── */}
          <div className="titleCont dataContainer">
            <Shimmer width={TITLE_WIDTHS[i % 10]} />
            {i % 3 !== 0 && <Shimmer width="55%" style={{ marginTop: 5 }} />}
          </div>

          {/* ── Company ── */}
          <div className="companyCont dataContainer companyContRow">
            <span className="lbSkeleton" style={{ width: 30, height: 30, borderRadius: 6, flexShrink: 0, marginRight: 9 }} />
            <div style={{ display: "flex", flexDirection: "column", gap: 4, flex: 1, minWidth: 0 }}>
              <Shimmer width={COMPANY_WIDTHS[i % 10]} />
              <Shimmer width="38%" height={11} style={{ marginTop: 2 }} />
            </div>
          </div>

          {/* ── Contact Location ── */}
          <div className="contactLocationCont dataContainer">
            <Shimmer width={LOC_WIDTHS[i % 10]} />
          </div>

          {/* ── Department ── */}
          <div className="deptCont dataContainer">
            <Shimmer width={DEPT_WIDTHS[i % 10]} />
          </div>

          {/* ── Seniority ── */}
          <div className="seniorityCont dataContainer">
            <Shimmer width={SENIO_WIDTHS[i % 10]} />
          </div>

          {/* ── Company Location ── */}
          <div className="locationCont dataContainer">
            <Shimmer width={CLOC_WIDTHS[i % 10]} />
          </div>

          {/* ── Company Size ── */}
          <div className="sizeCont dataContainer">
            <Shimmer width={SIZE_WIDTHS[i % 10]} />
          </div>

          {/* ── Annual Revenue ── */}
          <div className="revenueCont dataContainer">
            <Shimmer width={REV_WIDTHS[i % 10]} />
          </div>

          {/* ── Industry ── */}
          <div className="industryCont dataContainer">
            <Shimmer width={INDUS_WIDTHS[i % 10]} />
          </div>

          {/* ── Company Type ── */}
          <div className="companyTypeCont dataContainer">
            <Shimmer width={CTYPE_WIDTHS[i % 10]} />
          </div>

          {/* ── Email ── */}
          <div className="emailCont dataContainer">
            <Shimmer width={EMAIL_WIDTHS[i % 10]} />
          </div>

          {/* ── Mobile ── */}
          <div className="mobileCont dataContainer">
            <Shimmer width={PHONE_WIDTHS[i % 10]} />
          </div>
        </div>
      ))}
    </>
  );
};

export default ContactTableLoader;
export { ContactTableLoader };
